import { useState, type ReactNode } from "react";
import { NavLink } from "react-router-dom";
import { useAuth } from "../auth";
import { ProjectProvider, useProjects } from "../project-context";
import { getTheme, toggleTheme, type Theme } from "../theme";
import { Brand } from "./Logo";
import { BottomNav } from "./BottomNav";

function ProjectSwitch() {
  const { projects, selected, setSelectedId } = useProjects();
  if (projects.length === 0) return null;
  return (
    <select
      className="select proj-switch"
      value={selected?.id ?? ""}
      onChange={(e) => setSelectedId(e.target.value)}
    >
      {projects.map((p) => (
        <option key={p.id} value={p.id}>
          {p.name}
        </option>
      ))}
    </select>
  );
}

function MobileTopBar() {
  const [theme] = useState<Theme>(getTheme());
  return (
    <header className="topbar">
      <Brand theme={theme} height={26} />
      <ProjectSwitch />
    </header>
  );
}

function Sidebar() {
  const { user, logout } = useAuth();
  const [theme, setThemeState] = useState<Theme>(getTheme());
  return (
    <aside className="sidebar">
      <Brand theme={theme} height={34} />

      <nav className="nav">
        <NavLink to="/" end>
          <span className="dot" /> Oversikt
        </NavLink>
        <NavLink to="/realtime">
          <span className="dot" /> Sanntid
        </NavLink>
        <NavLink to="/vitals">
          <span className="dot" /> Ytelse
        </NavLink>
        <NavLink to="/issues">
          <span className="dot" /> Feil
        </NavLink>
        <NavLink to="/funnels">
          <span className="dot" /> Funnels
        </NavLink>
        <NavLink to="/uptime">
          <span className="dot" /> Oppetid
        </NavLink>
        <NavLink to="/releases">
          <span className="dot" /> Releases
        </NavLink>
        <NavLink to="/projects">
          <span className="dot" /> Prosjekter
        </NavLink>
      </nav>

      <div className="sidebar-foot">
        <div className="eyebrow" style={{ padding: "0 6px" }}>Aktivt prosjekt</div>
        <ProjectSwitch />
        <button className="theme-toggle" onClick={() => setThemeState(toggleTheme())}>
          {theme === "dark" ? "☾  Mørkt tema" : "☀  Lyst tema"}
        </button>
        <div className="foot-row">
          <span className="email">{user?.email}</span>
          <span className="spacer" />
          <button className="copy" onClick={() => logout()}>Logg ut</button>
        </div>
      </div>
    </aside>
  );
}

export function Shell({ children }: { children: ReactNode }) {
  return (
    <ProjectProvider>
      <div className="shell">
        <Sidebar />
        <MobileTopBar />
        <main className="content">{children}</main>
        <BottomNav />
      </div>
    </ProjectProvider>
  );
}
